"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[2099],{

/***/ 3933:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);
/* harmony import */ var _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4319);



class ByoFeatureController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = ['remainingCount', 'addProductButton']

  connect() {
    this.loadRemainingCount()
  }

  async loadRemainingCount() {
    if(this.hasRemainingCountTarget) {
      const reservedUnits = await _customer_storefront_repository__WEBPACK_IMPORTED_MODULE_1__["default"].getReservedUnits(
        this.remainingCountTarget.dataset.featuredVariantId,
      )
      const remainingUnits = Math.max(this.remainingCountTarget.dataset.startingCount - reservedUnits, 0)
      this.remainingCountTarget.innerHTML = remainingUnits

      if(remainingUnits === 0) {
        const addToCartButton = this.addProductButtonTargets.find((target) => {
          return target.dataset.variantId === this.remainingCountTarget.dataset.featuredVariantId
        })

        addToCartButton.disabled = true
        addToCartButton.innerHTML = "Out of stock"
        addToCartButton.dataset.alwaysDisable = 'true'
      }
    }
  }
}

Stimulus.register('byo-feature', ByoFeatureController)


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(3933)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);